import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import Loader from "../../../../components/Loader/Index";
import { beneDeniedAccount } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneTxnDeniedApproval,
  beneTxnMultiDeniedApproval,
  beneTxnViewAllAcc,
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalLoading,
} from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { beneInternalDeniedApproval } from "../../../../redux/features/internalApi/internalApi";
import { internalTxnDenied } from "../../../../redux/features/internalTransaction/internalTransactionDetailPage";
import { internalTxnMultiRejectApproval } from "../../../../redux/features/internalTransaction/internalTransactionSingleApproval";
import { internalTxnViewAll } from "../../../../redux/features/internalTransaction/internalTransactionViewAll";
import { scheduleInternalTxnView } from "../../../../redux/features/scheduleInternalTxn";
import {
  schedulesTxnReject,
  scheduleTxnView,
} from "../../../../redux/features/scheduleTransaction";
import {
  achivedAccountDetail,
  achivedAccountPan,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import TEXT from "../../../../utils/globalText";
import "./index.css";
import RejectingTransactionPopup from "./RejectingTransactionPopup/RejectingTransactionPopup";

const DeclinedPopup = ({
  onClose,
  accountId,
  accountName,
  allAccounts,
  updateAllAccounts,
  type,
  status,
  sideDrawer,
  ShowAccountName,
  pageName,
  pathName,
  Owner_account_number,
  showScheduleTxnPopup,
  setShowScheduleTxnPopup,
  setPendingTxnAlert,
  // showRejectTnxPopup,
  // setRejectTxnPopup,
  setAlertDetails,
  archive_id,
  setIsSidebarOpen,
  createArchive,
  createEdit,
  preventMultiEnter,
  setPreventMultiEnter,
  modaltype,
  closeBeneAccountDetailModal,
  txn_single_appr,
  modal_type,
  closeBeneTxnDetailModal,
  CloseModel,
  setTransactionFilterData,
  setTransactionFilterID,
  typeMulti,
  bene_txn_id,
  isMobile,
  closeInternalTxnDetailModal,
  scheduleAcc,
  internalAccount,
  accountId2,
  popup,
  beneid,
  associateschedule,
  handlecloseSchedule,
  associatePending,
  pendingTxnId,
  typePopup,
  setCheckLoaderState,
  setshowPopup,
}) => {
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showTransitionClass, setShowTransitionClass] = useState("");
  const [cancleButtonHide, SetCancleButtonHide] = useState(true);
  const [isFocus, setIsFocus] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  // const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);

  const { viewAccountDetailData } = useSelector((state) => state.verify);
  const { schedulesTxnViewAllData, schedulesTxnViewAllLoading } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );

  const [confirmButtonStyle, setConfirmButtonStyle] = useState({
    width: "100px",
    height: "42px",
    background: "transparent",
    boxShadow: "0px 3px 6px #00000029",
    border: "2px solid #CCCCCC",
    borderRadius: "20px",
    opacity: "0.55",
    cursor: "initial",
    color: "#000000", // Default color
  });
  const {
    beneTxnAccountData,
    BeneTxnDeniedApprovalLoading,
    BeneTxnMultiDeniedApprovalLoading,
  } = useSelector((state) => state.beneTxnViewAccData);

  const { beneDeniedApprovalLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  const { beneInternalDeniedApprovalLoading } = useSelector(
    (state) => state.internalAcc,
  );
  const { beneTxnViewAllAccLoading, beneTxnViewAllAccData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const { internalTxnData, internalTxnDeniedLoading } = useSelector(
    (state) => state?.internalTxnViewData,
  );
  const services = useSelector((state) => state.refreshToken.services);

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);

    const isEmpty = value.trim() === "";

    if (!isEmpty && value.replace(/\s+/g, "").length >= 10) {
      setConfirmButtonStyle({
        width: "100px",
        height: "42px",
        background: "#3CB371",
        boxShadow: "0px 3px 6px #00000029",
        border: "none",
        borderRadius: "20px",
        opacity: "1",
        cursor: "pointer",
        color: "#FFFFFF",
      });
    } else {
      setConfirmButtonStyle({
        width: "100px",
        height: "42px",
        background: "transparent",
        boxShadow: "0px 3px 6px #00000029",
        border: "2px solid #CCCCCC",
        borderRadius: "20px",
        opacity: "0.55",
        cursor: "initial",
        color: "#000000",
      });
    }
  };
  const handleBlur = () => {
    if (declineReason?.length === 0) {
      setIsFocus(false);
    }
  };

  const handleTxnMultiRejecting = () => {
    if (
      BeneTxnMultiDeniedApprovalLoading ||
      BeneTxnMultiDeniedApprovalLoading == null ||
      BeneTxnDeniedApprovalLoading ||
      internalTxnDeniedLoading
    ) {
      UniversalRefreshToast("Rejecting transaction");
    }
    setTimeout(() => {
      toast.dismiss();
    }, 2000);
  };

  const handleFocus = () => {
    setIsFocus(true);
  };

  const handleRejectScheduleTxn = async () => {
    setShowLoader(true);
    const AccountIdData = declineReason;
    let id2 =
      !schedulesTxnViewAllLoading &&
      schedulesTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? schedulesTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        schedulesTxnReject({
          id: id2,
          reason: declineReason,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";
        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        // setShowCancleBtn(true);
        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        handlecloseSchedule();
        setShowLoader(false);
        // await dispatch(viewAccountDetail({ id: beneid }));
        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, 1000);
      }
    }
  };

  const handleRejectAlert = async () => {
    setShowLoader(true);
    setInputDisabled(true);
    SetCancleButtonHide(false);

    let response = [];
    let queryParams = {
      page_no: 1,
      page_item_count: 50,
      lifecycle_status: "pending",
      beneficiary_account_id: accountId2,
    };
    response = await dispatch(beneTxnViewAllAcc(queryParams));
    const data = response?.payload?.transactions;

    if (data?.length > 0 && response?.payload?.status === true) {
      setShowLoader(false);
      handleConfirmAlert();
      onClose();
    }
  };

  const handleConfirmAlert = async () => {
    try {
      const AccountIdData = declineReason;
      let id = [];

      id =
        !beneTxnViewAllAccLoading &&
        beneTxnViewAllAccData?.transactions?.length > 0
          ? beneTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
          : [];

      UniversalRefreshToast("Rejecting transaction");
      let data = null;

      if (id.length > GlobalConfiguration?.lengthCheckZero) {
        data = await dispatch(
          beneTxnMultiDeniedApproval({ id, AccountIdData }),
        );

        setAlertDetails((prev) =>
          prev.map((item) =>
            item.keyId === accountId2
              ? {
                  ...item,
                  alertData: {
                    ...item.alertData,
                    pendingTxn: false,
                  },
                }
              : item,
          ),
        );

        if (data?.payload?.status === true) {
          CommonToast({
            text: "Transaction(s) rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
      }

      setPendingTxnAlert(false);
    } catch (error) {
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
  };

  const handleRejectScheduleAlert = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);
    SetCancleButtonHide(false);

    let response = [];
    let response1 = [];

    let queryParams1 = {
      page_no: 1,
      page_item_count: PaginationConfiguration.paginationSmall,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };

    response1 = await dispatch(scheduleTxnView(queryParams1));

    const data = response?.payload?.transactions;
    const data1 = response1?.payload?.transactions;

    if (
      data1?.length > GlobalConfiguration.lengthCheckZero &&
      response1?.payload?.status === true
    ) {
      setShowLoader(false);
      handleRejectScheduleTxn(id, AccountIdData);
      // handleConfirm(id, AccountIdData);
    }

    setInputDisabled(false);
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);

    setCheckLoaderState(true);

    SetCancleButtonHide(false);

    let response = [];
    let response1 = [];

    if (
      type === "internalAccount" ||
      type === "Internal_AccountApproval" ||
      type === "Internal_Account_Detail" ||
      typePopup === "RejectAllTransactionPopup"
    ) {
      let queryParams = {
        page_no: 1,
        page_item_count: 50,
        lifecycle_status: "pending",
        internal_account_id: id,
      };

      response = await dispatch(internalTxnViewAll(queryParams));

      let queryParamsInternal = {
        page_no: 1,
        page_item_count: 50,
        lifecycle_status: "pending",
        internal_account_id: id,
      };

      response1 = await dispatch(scheduleInternalTxnView(queryParamsInternal));
    } else {
      let queryParams = {
        page_no: 1,
        page_item_count: 50,
        lifecycle_status: "pending",
        beneficiary_account_id: id,
      };
      response = await dispatch(beneTxnViewAllAcc(queryParams));

      let queryParams1 = {
        page_no: 1,
        page_item_count: 50,
        lifecycle_status: "pending",
        beneficiary_account_id: id,
      };

      response1 = await dispatch(scheduleTxnView(queryParams1));
    }
    const data = response?.payload?.transactions;
    const data1 = response1?.payload?.transactions;
    if (data?.length > 0 && response?.payload?.status === true) {
      setRejectTxnPopup(true);
      setShowLoader(false);
      setPreventMultiEnter(true);
    } else if (data1?.length > 0 && response1?.payload?.status === true) {
      setShowScheduleTxnPopup(true);
      setShowLoader(false);
    } else {
      if (
        type === "Internal_AccountApproval" ||
        type === "Internal_Account_Detail"
      ) {
        handleInternalAccountreject(id, AccountIdData);
      } else if (data1?.length === 0) {
        handleConfirm(id, AccountIdData);
      }
    }
    await dispatch(viewAccountDetail({ id: accountId }));
    setTimeout(() => {
      setCheckLoaderState(false);
      setShowLoader(false);
      setshowPopup(false);
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);
    setInputDisabled(false);
  };

  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);

    UniversalRefreshToast("accountsRefresh");

    if (!beneDeniedApprovalLoading || beneDeniedApprovalLoading === null) {
      const data = await dispatch(beneDeniedAccount({ id, AccountIdData }));
      if (data?.payload?.errors?.user_unauthorized?.length > 0) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ABeneficiaryTxn",
          },
        });
        return;
      }

      setShowLoader(true);
      SetCancleButtonHide(false);
      await new Promise((resolve) => {
        setTimeout(resolve, 2000);
      });

      if (type === "decline account details" || type === "scheduleAcc") {
        if (data?.payload?.status === false || data?.payload === undefined) {
          let error_msg = "";
          let error_list = null;
          if (data?.payload === undefined) {
            error_msg = "An error occured while taking action on this account";
          } else if (data?.payload?.errors?.beneficiary_account) {
            if (data?.payload?.errors?.beneficiary_account?.length > 1) {
              error_list = data?.payload?.errors?.beneficiary_account;
              error_msg = data?.payload?.errors?.beneficiary_account[0];
            } else {
              error_msg = data?.payload?.errors?.beneficiary_account;
              CommonToast({
                text: error_msg[0],
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }
          } else if (data?.payload?.errors?.bank_account_number?.[0]) {
            error_msg = data?.payload?.errors?.bank_account_number[0];
          }

          if (error_msg === "Beneficiary account already rejected") {
            const newData = await dispatch(viewAccountDetail({ id }));
            const updatedBeneficiaryAccount = {
              ...newData?.payload?.beneficiary_accounts?.[0],
              error_msg,
              error: data?.payload?.status === false ? true : false,
            };

            const updatedData = allAccounts.map((item) => {
              if (item.id === id) {
                return {
                  ...item,
                  ...(updatedBeneficiaryAccount || {}),
                };
              }
              return item;
            });
            updateAllAccounts(updatedData);
          } else {
            const updatedData = allAccounts.map((item) => {
              if (item.id === id) {
                return {
                  ...item,
                  error_msg,
                  error: data?.payload?.status === false ? true : false,
                };
              }
              return item;
            });
            updateAllAccounts(updatedData);
          }
          setShowLoader(false);
          setInputDisabled(false);
          setDeclineReason("");
          onClose();
          if (Array.isArray(error_list) && error_list.length > 1) {
            error_list.forEach((err) => {
              setTimeout(() => {
                CommonToast({
                  text: err,
                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
              }, 500);
            });
          } else {
            CommonToast({
              text: error_msg,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }
        } else {
          const updatedData = allAccounts.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "rejected" : "pending",

                rejected_on:
                  data?.payload?.status === true
                    ? data?.payload?.beneficiary_accounts[0]?.rejected_on
                    : "",
                rejected_by_name:
                  data?.payload?.status === true
                    ? data?.payload?.beneficiary_accounts[0]?.rejected_by_name
                    : "",
                rejection_reason: AccountIdData,
                error:
                  item.error === false && data?.payload?.status === false
                    ? true
                    : false,
                message:
                  item.message === "" && data?.payload?.status === false
                    ? data?.payload?.errors?.beneficiary_account[0]
                    : "",
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
          setShowLoader(false);
          setInputDisabled(false);
          setDeclineReason("");
          onClose();
          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          if (pathName) {
            setTimeout(() => {
              Navigate(pathName);
            }, 5000);
          }
          // }
          if (modaltype === "bene_account_detail_modal") {
            setTimeout(() => {
              closeBeneAccountDetailModal();
              window.location.reload();
            }, 5000);
          }
          if (pageName === "Success page decline account") {
            sessionStorage.setItem(
              "Create BeneAcc Approve and Decline status",
              true,
            );
            Navigate(
              `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
            );
          }
          if (txn_single_appr === "txn_single_approval") {
            Navigate(-1);
          }
        }
      } else {
        if (data?.payload?.status === false) {
          let error_msg = "";
          if (data?.payload?.errors?.beneficiary_account?.[0]) {
            error_msg = data?.payload?.errors?.beneficiary_account[0];
          } else if (data?.payload?.errors?.bank_account_number?.[0]) {
            error_msg = data?.payload?.errors?.bank_account_number[0];
          } else {
            error_msg = "An unknown error occurred.";
          }
          const updatedData = allAccounts?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "error" : "pending",

                rejected_on:
                  data.payload.status === true
                    ? data?.payload?.beneficiary_accounts[0]?.rejected_on
                    : "",
                rejected_by_name:
                  data.payload.status === true
                    ? data?.payload?.beneficiary_accounts[0]?.rejected_by_name
                    : "",
                rejection_reason: AccountIdData,
                error:
                  item.error === "false" && data?.payload?.status === false
                    ? "true"
                    : "false",
                message: data?.payload?.status === false ? error_msg : "",
              };
            }
            return item;
          });

          updateAllAccounts(updatedData);

          setShowLoader(false);
          setInputDisabled(false);
          setDeclineReason("");
          onClose();
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        } else {
          const updatedData = allAccounts.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "rejected" : "pending",

                rejected_on:
                  data?.payload?.status === true
                    ? data?.payload?.beneficiary_accounts[0]?.rejected_on
                    : "",
                rejected_by_name:
                  data?.payload?.status === true
                    ? data?.payload?.beneficiary_accounts[0]?.rejected_by_name
                    : "",
                rejection_reason: AccountIdData,
                error:
                  item.error === "false" && data?.payload?.status === false
                    ? "true"
                    : "false",
                message:
                  item.message === "" && data?.payload?.status === false
                    ? data?.payload?.errors?.beneficiary_account[0]
                    : "",
              };
            }
            return item;
          });

          updateAllAccounts(updatedData);
          setShowLoader(false);
          setInputDisabled(false);
          setDeclineReason("");
          onClose();
          if (data?.payload?.status === true) {
            CommonToast({
              text: "Account rejected successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }
        }

        await dispatch(viewAccountDetail({ id: beneid }));
      }
    }
  };

  const handleInternalAccountreject = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !beneInternalDeniedApprovalLoading ||
      beneInternalDeniedApprovalLoading === null
    ) {
      const data = await dispatch(
        beneInternalDeniedApproval({ id, AccountIdData }),
      );

      if (data?.payload?.errors?.user_unauthorized?.length > 0) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      setShowLoader(true);
      SetCancleButtonHide(false);
      await new Promise((resolve) => {
        setTimeout(resolve, 2000);
      });

      if (data?.payload?.status === false) {
        let error_msg = "";
        if (data?.payload?.errors?.internal_account?.[0]) {
          error_msg = data?.payload?.errors?.internal_account[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = data?.payload?.errors?.bank_account_number[0];
        } else {
          error_msg = "An unknown error occurred.";
        }
        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" &&
                status === "Internal_Account_Detail"
                  ? "pending"
                  : "error",
              rejected_on:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message: data?.payload?.status === false ? error_msg : "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        setShowLoader(false);
        setInputDisabled(false);
        setDeclineReason("");
        onClose();
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item?.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message:
                item?.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.internal_accounts[0]
                  : "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setInputDisabled(false);
        setDeclineReason("");
        onClose();
        if (data?.payload?.status === true) {
          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        if (
          type === "Internal_Account_Detail" &&
          type === "Internal_AccountApproval" &&
          popup === "bene_account_detail_modal"
        ) {
          setTimeout(() => {
            // closeBeneAccountDetailModal();
            window.location.reload();
          }, 5000);
        }
      }
    }
  };

  const BeneTxnDeclinedPopUp = async (id, AccountIdData) => {
    if (!sessionStorage.getItem("q2p_token")) {
      setIsSidebarOpen(false);
      return;
    }
    setShowLoader(true);

    setInputDisabled(true);
    SetCancleButtonHide(false);
    if (sideDrawer === "SideDrawer") {
      UniversalRefreshToast("accountsRefresh");

      const data = await dispatch(beneDeniedAccount({ id, AccountIdData }));

      if (data?.payload?.errors?.user_unauthorized?.length > 0) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ABeneficiaryTxn",
          },
        });
        return;
      }
      let result5 = "";
      let result6 = "";
      let result7 = "";
      let totalData1 = "";
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (data && data?.payload?.errors?.base?.[0] !== "Invalid token format") {
        const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
          (item) => {
            if (item.id === id) {
              let lifecycleStatus = "";

              if (data.payload.status === true) {
                lifecycleStatus = "rejected";
              }
              if (data.payload.status === false) {
                lifecycleStatus = "error";
              }

              return {
                ...item,
                approval_status:
                  item.approval_status === "pending"
                    ? lifecycleStatus
                    : "pending",
                status: data?.payload?.status,
                message:
                  data?.payload?.status === false
                    ? data?.payload?.errors?.beneficiary_account?.[0]
                    : "",
              };
            }
            return item;
          },
        );

        if (data?.payload.status === false) {
          if (data?.payload.status === false) {
            if (
              data?.payload?.errors?.bank_account_number?.[0] &&
              data?.payload?.errors?.permanent_account_number?.[0] &&
              data?.payload?.errors?.beneficiary_account?.[0]
            ) {
              result5 = data?.payload?.errors?.bank_account_number[0];
              result6 = data?.payload?.errors.permanent_account_number[0];
              result7 = data.payload.errors.beneficiary_account[0];
              totalData1 = [result5, result6, result7];

              totalData1.forEach((error5) => {
                if (data?.payload?.status === false) {
                  setTimeout(() => {
                    CommonToast({
                      text: error5,
                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                  }, 800);
                }
              });
            } else if (
              !data?.payload?.errors?.user_unauthorized?.[0] &&
              data?.payload?.errors?.beneficiary_account.length >= 0
            ) {
              const res = data.payload.errors.beneficiary_account;
              res.forEach((err8) => {
                if (data?.payload?.status === false) {
                  setTimeout(() => {
                    CommonToast({
                      text: err8,
                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                  }, 1000);
                }
              });
            } else if (data?.payload?.errors?.user_unauthorized?.[0]) {
              if (data?.payload?.status === false) {
                setTimeout(() => {
                  CommonToast({
                    text: data?.payload?.errors?.user_unauthorized?.[0],
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  });
                }, 1000);
              }
            }
          }
        } else {
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        updateAllAccounts(updatedData[0]);
      }
    } else if (sideDrawer === "multiApproval") {
      handleTxnMultiRejecting();
      const data = await dispatch(
        beneTxnMultiDeniedApproval({ id, AccountIdData }),
      );
      dispatch(resetBeneTxnMultiApprovalError());
      dispatch(resetBeneTxnMultiDeniedApprovalLoading());
      await new Promise((resolve) => setTimeout(resolve, 2000));
      SetCancleButtonHide(false);

      if (data?.payload?.status === 500) {
        setTimeout(() => {
          CommonToast({
            text: data?.payload?.error,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }, 1000);
      } else if (data?.payload?.errors?.user_unauthorized?.[0]) {
        setTimeout(() => {
          Navigate("/feature_not_assigned", {
            state: {
              unavailableService: "VBeneficiaryTxn",
            },
          });
        }, 1000);
      } else if (data?.payload?.status === false) {
        // const error_msg = data?.payload?.errors?.base[0]
        //   ? data?.payload?.errors?.base[0]
        //   : data?.payload?.errors?.base[0].errors[0];
        //  CommonToast({
        //    text: error_msg,
        //    icon: ICONS?.ERROR_WHITE_CIRCLE,
        //    variant: "var(--error)",
        //    buttonNeeded: false,
        //  });

        Navigate(
          "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/error",
        );
      } else {
        Navigate(
          "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/declined",
        );
      }
    } else {
      handleTxnMultiRejecting();

      const data = await dispatch(beneTxnDeniedApproval({ id, AccountIdData }));

      await new Promise((resolve) =>
        setTimeout(() => {
          resolve();
        }, 2000),
      );
      if (data?.payload?.status === 500) {
        setTimeout(() => {
          CommonToast({
            text: data?.payload?.error,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }, 1000);
      } else if (data?.payload?.errors?.user_unauthorized?.[0]) {
        setTimeout(() => {
          Navigate("/feature_not_assigned", {
            state: {
              unavailableService: "VBeneficiaryTxn",
            },
          });
        }, 1000);
      } else {
        SetCancleButtonHide(false);
        const updatedData = allAccounts.map((item) => {
          if (item?.txn_id === id) {
            let lifecycleStatus = "";
            let errorMessage = "";

            if (
              data.payload.status === true &&
              data.payload.transactions[0].lifecycle_status === "rejected"
            ) {
              lifecycleStatus = data.payload.transactions[0].lifecycle_status;
            }

            if (
              data?.payload?.errors?.base[0]?.errors &&
              data?.payload?.errors?.base[0]?.errors[0]
            ) {
              errorMessage = data.payload.errors.base[0].errors[0];
              if (data?.payload?.errors?.base[0]?.errors?.length >= 1) {
                let msg3 = data.payload.errors.base[0].errors;
                msg3.forEach((error2) => {
                  if (data?.payload?.status === false) {
                    setTimeout(() => {
                      CommonToast({
                        text: error2,
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                        buttonNeeded: false,
                      });
                    }, 1000);
                  }
                });
              }
            } else if (data?.payload?.errors?.base[0]) {
              errorMessage = data.payload.errors.base[0];
            } else if (
              data?.payload?.status === true &&
              data?.payload?.transactions[0].lifecycle_status === "pending"
            ) {
              lifecycleStatus = "pendingOne";
            }

            return {
              ...item,
              lifecycle_status:
                data?.payload?.status === true &&
                item.lifecycle_status === "pending"
                  ? lifecycleStatus
                  : "error",
              rejected: true,
              rejection_reason: AccountIdData,
              error:
                item.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message:
                item.message === "" && data?.payload?.status === false
                  ? errorMessage
                  : "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        if (data?.payload.status === false) {
          const error_msg = data?.payload?.errors?.base[0]
            ? data?.payload?.errors?.base[0]
            : data?.payload?.errors?.base[0].errors[0];
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        } else {
        }
      }
    }
    setShowTransitionClass("transition-effect");

    setShowLoader(false);
    setInputDisabled(false);
    setDeclineReason("");
    onClose();
  };

  const BeneTxnDeclinedDtls = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);
    handleTxnMultiRejecting();
    if (sideDrawer === "SideDrawer") {
      UniversalRefreshToast("accountsRefresh");

      const data = await dispatch(beneDeniedAccount({ id, AccountIdData }));

      if (data?.payload?.errors?.user_unauthorized?.length > 0) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ABeneficiaryTxn",
          },
        });
        return;
      }

      if (data) {
        const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
          (item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "rejected" : "approved",
                status: data?.payload?.status,
                message:
                  data?.payload?.status === false
                    ? data?.payload?.errors?.beneficiary_account[0]
                    : "",
              };
            }
            return item;
          },
        );
        if (data?.payload.status === false) {
          CommonToast({
            text: data?.payload?.errors?.beneficiary_account[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        } else {
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        updateAllAccounts(updatedData[0]);
      }
    } else {
      let data = {};
      if (status === "internal-transaction") {
        data = await dispatch(internalTxnDenied({ id, AccountIdData }));
      } else {
        data = await dispatch(beneTxnDeniedApproval({ id, AccountIdData }));
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));

      if (data?.payload?.errors?.user_unauthorized?.[0]) {
        setTimeout(() => {
          Navigate("/feature_not_assigned", {
            state: {
              unavailableService: "VBeneficiaryTxn",
            },
          });
        }, 1000);
      } else {
        SetCancleButtonHide(false);
        const updatedData = allAccounts.map((item) => {
          if (item?.txn_id === id) {
            let lifecycleStatus = "";
            let errorMessage = "";

            if (
              data.payload.status === true &&
              data.payload.transactions[0].lifecycle_status === "rejected"
            ) {
              lifecycleStatus = data.payload.transactions[0].lifecycle_status;
            } else if (
              data?.payload?.errors?.base[0]?.errors &&
              data?.payload?.errors?.base[0]?.errors[0]
            ) {
              errorMessage = data.payload.errors.base[0].errors[0];
              if (data?.payload?.errors?.base[0]?.errors.length >= 1) {
                let msg1 = data?.payload?.errors?.base[0]?.errors;
                msg1.forEach((error1) => {
                  if (data?.payload?.status === false) {
                    setTimeout(() => {
                      CommonToast({
                        text: error1,
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                        buttonNeeded: false,
                      });
                    }, 1000);
                  }
                });
              }
            } else if (data?.payload?.errors?.base[0]) {
              errorMessage = data.payload.errors.base[0];
              CommonToast({
                text: errorMessage,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            } else if (
              data.payload.status === true &&
              data.payload.transactions[0].lifecycle_status === "pending"
            ) {
              lifecycleStatus = "pendingOne";
            }

            return {
              ...item,
              lifecycle_status:
                data?.payload.status === true &&
                item.lifecycle_status === "pending"
                  ? lifecycleStatus
                  : "pending",
              rejected: true,
              rejection_reason: AccountIdData,
              logs: data?.payload?.transactions?.[0]?.logs
                ? data?.payload?.transactions[0]?.logs
                : status === "internal-transaction"
                  ? internalTxnData?.transaction?.[0]?.logs || []
                  : beneTxnAccountData?.transaction?.[0]?.logs || [],
              error:
                item.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message:
                item.message === "" && data?.payload?.status === false
                  ? errorMessage
                  : "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        if (data?.payload?.status === false) {
          const error_msg = data?.payload?.errors?.base[0]
            ? data?.payload?.errors?.base[0]
            : data?.payload?.errors?.base[0].errors[0];
        } else {
          if (typeMulti === "MultiApproval_Session_Data") {
            let storedData = JSON.parse(sessionStorage.getItem("selectedData"));

            if (storedData) {
              const updatedTransactions =
                storedData.selectedSendTransactions.filter(
                  (transaction) => transaction.txn_id !== bene_txn_id,
                );
              const updatedTransactionsId =
                storedData.selectedTransactions.filter(
                  (transaction) => transaction !== bene_txn_id,
                );

              sessionStorage.setItem(
                "selectedData",
                JSON.stringify({
                  ...storedData,
                  selectedSendTransactions: updatedTransactions,
                  selectedTransactions: updatedTransactionsId,
                }),
              );
              setTransactionFilterData(updatedTransactions);
              setTransactionFilterID(updatedTransactionsId);
            }
            CommonToast({
              text: "Transaction rejected successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });

            if (modal_type === "bene_txn_detail_modal") {
              setTimeout(() => {
                closeBeneTxnDetailModal();
                window.location.reload();
              }, 5000);
            }
          } else {
            CommonToast({
              text: "Transaction rejected successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }

          if (
            modal_type === "bene_txn_detail_modal" ||
            modal_type === "internal_txn_detail_modal" ||
            status === "internal-transaction"
          ) {
            let getSessionData = JSON.parse(
              sessionStorage.getItem("selectedData"),
            );
            let selectedSendTransactions =
              getSessionData?.selectedSendTransactions?.filter(
                (fil) => fil.txn_id !== id,
              );
            let selectedTransactions =
              getSessionData?.selectedTransactions?.filter((fil) => fil !== id);
            sessionStorage.setItem(
              "selectedData",
              JSON.stringify({
                selectedSendTransactions: selectedSendTransactions,
                selectedTransactions: selectedTransactions,
              }),
            );
            setTimeout(
              () => {
                if (
                  modal_type === "bene_txn_detail_modal" ||
                  modal_type === "internal_txn_detail_modal"
                ) {
                  modal_type === "bene_txn_detail_modal"
                    ? closeBeneTxnDetailModal()
                    : closeInternalTxnDetailModal();
                  window.location.reload();
                } else if (status === "internal-transaction") {
                  if (
                    selectedSendTransactions?.length === 0 &&
                    selectedTransactions?.length === 0
                  ) {
                    Navigate(
                      `/internal_transaction_dashboard/internal_transaction_multi_approval`,
                    );
                  } else {
                    Navigate(-1);
                  }
                }
              },
              status === "internal-transaction" ? 1000 : 5000,
            );
          }
        }
      }
    }
    setShowTransitionClass("transition-effect");
    setShowLoader(false);
    setInputDisabled(false);
    setDeclineReason("");
    onClose();
  };

  const { internalTxnViewAllAccData, internalTxnViewAllAccLoading } =
    useSelector((state) => state?.internalTxnViewall);

  const handlePendingTxn = async (id) => {
    setShowLoader(true);
    setInputDisabled(true);
    let AccountIdData = declineReason;

    let all_txn_id;

    all_txn_id =
      !beneTxnViewAllAccLoading &&
      beneTxnViewAllAccData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? beneTxnViewAllAccData.transactions.map((t) => t.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");
    let data;
    data = await dispatch(
      beneTxnDeniedApproval({
        id: all_txn_id,
        AccountIdData,
      }),
    );

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      Navigate("/feature_not_assigned", {
        state: {
          unavailableService: "ABeneficiaryTxn",
        },
      });
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 2000));

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized?.[0]
        : data?.payload?.errors?.base?.[0]?.errors?.[0]
          ? data?.payload?.errors?.base?.[0]?.errors?.[0]
          : data?.payload?.errors?.base?.[0];

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setTimeout(() => {
        onClose();
      }, 500);
    } else if (data?.payload?.status) {
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await dispatch(viewAccountDetail({ id: archive_id }));
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occured while taking action on this account.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setShowLoader(false);
    onClose();
    setInputDisabled(false);
  };

  const handleRejectAllTransaction = async () => {
    setShowLoader(true);
    setInputDisabled(true);
    let AccountIdData = declineReason;

    let all_txn_id = [];
    if (
      window.location.pathname.includes(
        "/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/",
      )
    ) {
      all_txn_id =
        !internalTxnViewAllAccLoading &&
        internalTxnViewAllAccData?.transactions?.length > 0
          ? internalTxnViewAllAccData?.transactions.map((data) => {
              return data?.txn_id;
            })
          : [];
    } else {
      all_txn_id =
        !beneTxnViewAllAccLoading &&
        beneTxnViewAllAccData?.transactions?.length > 0
          ? beneTxnViewAllAccData?.transactions.map((data) => {
              return data?.txn_id;
            })
          : [];
    }

    UniversalRefreshToast("Rejecting transaction");
    let data = [];
    if (
      window.location.pathname.includes(
        "/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/",
      )
    ) {
      data = await dispatch(
        internalTxnMultiRejectApproval({ id: all_txn_id, AccountIdData }),
      );
    } else {
      data = await dispatch(
        beneTxnMultiDeniedApproval({ id: all_txn_id, AccountIdData }),
      );
    }

    if (data?.payload?.errors?.user_unauthorized?.length > 0) {
      Navigate("/feature_not_assigned", {
        state: {
          unavailableService: "ABeneficiaryTxn",
        },
      });
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 2000));

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized?.[0]
        : data?.payload?.errors?.base?.[0]?.errors?.[0]
          ? data?.payload?.errors?.base?.[0]?.errors?.[0]
          : data?.payload?.errors?.base?.[0];
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setTimeout(() => {
        onClose();
      }, 500);
    } else if (data?.payload?.status) {
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      let thunkAction = achivedAccountDetail;

      UniversalRefreshToast("archive");
      let archived_response;
      if (createArchive == "createArchive") {
        archived_response = await dispatch(
          achivedAccountPan({ id: archive_id }),
        );
      } else {
        archived_response = await dispatch(thunkAction({ id: archive_id }));
        if (archived_response?.payload?.status === true) {
          CommonToast({
            text: "Account archived successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
      }

      if (
        (archived_response.type !== "achivedAccountDetail/rejected" ||
          archived_response.payload ===
            "Beneficiary account already archived") &&
        !createEdit
      ) {
        await dispatch(viewAccountDetail({ id: archive_id }));
      }
      if (
        window.location.pathname !==
          "/beneficiary_account_dashboard/create_beneficiary_account" &&
        archived_response?.payload?.status === true
      ) {
        if (
          !window.location.pathname?.includes(
            "/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/PAN_Details/",
          )
        ) {
          CommonToast({
            text: "Account archived successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
      } else if (archived_response?.payload?.status === false) {
        const error_msg =
          archived_response?.payload?.errors?.beneficiary_account?.[0];

        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
      setTimeout(() => {
        onClose();
      }, 500);
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occured while taking action on this account.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    setInputDisabled(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      if (emojiRegex.test(event.key)) {
        event.preventDefault();
        return;
      }

      if (event.key === "Enter" && !inputDisabled) {
        if (declineReason.replace(/\s+/g, "").length >= 10) {
          if (
            status === "Transaction" ||
            status === "MultiApprovalDeclinedTransaction"
          ) {
            BeneTxnDeclinedPopUp(accountId, declineReason);
          } else if (
            status === "Transaction-bene" ||
            status === "internal-transaction"
          ) {
            BeneTxnDeclinedDtls(accountId, declineReason);
          } else if (
            status === "Internal_AccountApproval" ||
            status === "Internal_Account_Detail"
          ) {
            if (!showRejectTnxPopup) {
              handleRejectTransactionChecker(accountId, declineReason);
            }
          } else if (status === "Reject-All-Transaction") {
            if (!showLoader) {
              if (associatePending === "AlertPendingTxn") {
                handlePendingTxn(pendingTxnId);
              } else {
                handleRejectAllTransaction();
              }
            }
          } else if (
            !beneDeniedApprovalLoading ||
            beneDeniedApprovalLoading === null
          ) {
            if (!preventMultiEnter) {
              if (type === "BeneAccAlert") {
                handleRejectAlert();
              } else if (associateschedule === "AlertSchedule") {
                handleRejectScheduleAlert(beneid, declineReason);
              } else {
                handleRejectTransactionChecker(accountId, declineReason);
              }
            }
          }
        }
      }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    inputDisabled,
    declineReason,
    accountId,
    status,
    preventMultiEnter,
    showLoader,
  ]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };
  return (
    <>
      {true && (
        <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center  z-[2147483647]">
          <RejectingTransactionPopup
            accountId={accountId}
            accountName={accountName}
            accountNumber={Owner_account_number ? Owner_account_number : ""}
            declineReason={declineReason}
            handleClosePopup={onClose}
            handleConfirm={handleConfirm}
            handleInternalAccountreject={handleInternalAccountreject}
            setRejectTxnPopup={setRejectTxnPopup}
            showRejectTnxPopup={showRejectTnxPopup}
            setShowScheduleTxnPopup={setShowScheduleTxnPopup}
            isTest={true}
            type={type}
          />
        </div>
      )}
      {showScheduleTxnPopup && (
        <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center  z-[2147483647]">
          <RejectingTransactionPopup
            accountId={accountId}
            accountName={accountName}
            accountNumber={Owner_account_number ? Owner_account_number : ""}
            declineReason={declineReason}
            handleClosePopup={onClose}
            handleConfirm={handleConfirm}
            handleInternalAccountreject={handleInternalAccountreject}
            setShowScheduleTxnPopup={setShowScheduleTxnPopup}
            showScheduleTxnPopup={showScheduleTxnPopup}
            type={
              type === "Internal_Account_Detail" ||
              type === "Internal_AccountApproval"
                ? "scheduleInternalAcc"
                : "scheduleAcc"
            }
          />
        </div>
      )}
      <div className="mainPopup">
        {status === "Transaction" ? (
          <div className="DeclinedAndpopup animate-none Qmd:animate-slideInFromRight">
            <div
              className="declinedReasion"
              // style={{
              //   marginTop: isMobile ? "-20px" : "",
              // }}
            >
              <h2>Rejected reason</h2>
              {ShowAccountName ? (
                <p>Please state the reason for rejecting the account</p>
              ) : (
                <p>Please state the reason for rejecting the transaction</p>
              )}
            </div>

            <div
              className={`Beneinputfield ${
                declineReason.length >= 9 ? "valid" : ""
              }`}
              style={{
                marginTop:
                  isFocus && window.innerWidth < 600
                    ? "15px"
                    : window.innerWidth < 600
                      ? "15px"
                      : "20px",
              }}
            >
              <input
                style={{
                  border:
                    declineReason.replace(/\s+/g, "").length >= 10
                      ? "1px solid var(--settled)"
                      : isFocus
                        ? "1px solid var(--text-secondary)"
                        : "1px solid var(--text-secondary)",
                  pointerEvents: inputDisabled ? "none" : "auto",
                  disabled: inputDisabled ? "true" : "false",
                  width: "95%",
                  maxWidth: "520px",
                  height: "42px",
                  font: "16px",
                  padding: "0px 10px",
                  background: "transparent",
                  borderRadius: "10px",
                  outline: "none",
                  opacity: "1",
                }}
                type="text"
                inputMode="text"
                pattern="[A-Za-z0-9\s]*"
                value={declineReason}
                onChange={handleInputChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                disabled={inputDisabled}
              />
              <label
                htmlFor=""
                for="myInput"
                style={{
                  top: isFocus ? "-0px" : "22px",
                  fontSize: isFocus ? "var(--font-xs)" : "var(--font-md)",
                  background: "var(--Blue-3)",
                  color:
                    declineReason.replace(/\s+/g, "").length >= 10
                      ? "var(--settled)"
                      : isFocus
                        ? "var(--text-secondary)"
                        : "var(--text-secondary)",
                }}
              >
                Reason
              </label>
            </div>
            <div
              className="mb-[20px]"
              // style={{ paddingLeft: window.innerWidth < 600 ? "14px" : "32px" }}
            >
              <p
                className="w-full h-[19px] font-sans text-text-secondary text-font-sm font-normal leading-[19px] flex-none order-1"
                style={{
                  marginTop: isMobile ? "15px" : "10px",
                  marginLeft: isMobile ? "4.5%" : "4.5%",
                }}
              >
                Note - The reason must consist of at least 10 characters.
              </p>
            </div>
            <div
              className="BeneTxn_benefbtnconfandCan"
              // style={{ marginTop: isMobile ? "20px" : "" }}
            >
              {showLoader ? (
                <div>
                  <Loader />
                </div>
              ) : (
                <div
                  className="flex items-center gap-[20px]"
                  style={{ marginBottom: isMobile ? "10px" : "" }}
                >
                  {cancleButtonHide && (
                    <button
                      id="cancelBtn"
                      onClick={onClose}
                      className={`cancleBtn ${showTransitionClass}`}
                    >
                      Cancel
                    </button>
                  )}

                  <button
                    // className={`confirmBtn ${showTransitionClass}`}
                    className={`${
                      declineReason.replace(/\s+/g, "").length < 10
                        ? "confirmBtn"
                        : "confirm-btn-enable"
                    }`}
                    // onClick={() =>
                    //   status ===
                    //   ("Transaction" || "MultiApprovalDeclinedTransaction")
                    //     ? BeneTxnDeclinedPopUp(accountId, declineReason)
                    //     : handleConfirm(accountId, declineReason)
                    // }
                    onClick={() => {
                      if (
                        services?.find(
                          (service) =>
                            service === "ABeneficiaryTxn" ||
                            service === "Admin",
                        ) !== undefined
                      ) {
                        status ===
                        ("Transaction" || "MultiApprovalDeclinedTransaction")
                          ? BeneTxnDeclinedPopUp(accountId, declineReason)
                          : handleConfirm(accountId, declineReason);
                      } else {
                        Navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ABeneficiaryTxn",
                          },
                        });
                      }
                    }}
                    disabled={
                      inputDisabled ||
                      declineReason.replace(/\s+/g, "").length < 10
                    } // pp
                    style={{
                      cursor:
                        inputDisabled ||
                        declineReason.replace(/\s+/g, "").length <= 10
                          ? "default"
                          : "pointer",
                    }}
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : status === "Transaction-bene" ||
          status === "internal-transaction" ? (
          <div
            className="DeclinedAndpopup animate-none Qmd:animate-slideInFromRight"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <div className="declinedReasion">
                <h2>Rejected reason</h2>
                <p>Please state the reason for rejecting the transaction</p>
              </div>

              <div
                className={`Beneinputfield ${
                  declineReason.length >= 9 ? "valid" : ""
                }`}
                style={{ marginTop: "20px" }}
              >
                <input
                  style={{
                    border:
                      declineReason.replace(/\s+/g, "").length >= 10
                        ? "1px solid var(--settled)"
                        : isFocus
                          ? "1px solid var(--text-secondary)"
                          : "1px solid var(--text-secondary)",
                    pointerEvents: inputDisabled ? "none" : "auto",
                    disabled: inputDisabled ? "true" : "false",
                    width: "520px",
                    height: "42px",
                    font: "16px",
                    padding: "0px 10px",
                    background: "transparent",
                    borderRadius: "10px",
                    outline: "none",
                    opacity: "1",
                  }}
                  type="text"
                  value={declineReason}
                  onChange={handleInputChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  disabled={inputDisabled}
                />
                <label
                  htmlFor=""
                  for="myInput"
                  style={{
                    top: isFocus ? "-0px" : "22px",
                    fontSize: isFocus ? "var(--font-xs)" : "var(--font-md)",
                    background: "var(--Blue-3)",
                    color:
                      declineReason.replace(/\s+/g, "").length >= 10
                        ? "var(--settled)"
                        : isFocus
                          ? "var(--text-secondary)"
                          : "var(--text-secondary)",
                  }}
                >
                  Reason
                </label>
              </div>
              <div className="txn_note mt-[10px] mb-[20px]">
                <p className="font-sans text-text-secondary text-font-sm font-normal leading-[19px] flex-none order-1">
                  Note - The reason must consist of at least 10 characters.
                </p>
              </div>
              <div className="BeneTxn_benefbtnconfandCan">
                {showLoader ? (
                  <div>
                    <Loader />
                  </div>
                ) : (
                  <div className="flex items-center gap-[10px] mobDeclineCancelConfirmS">
                    {cancleButtonHide && (
                      <button
                        id="cancelBtn"
                        onClick={onClose}
                        className={`cancleBtn ${showTransitionClass}`}
                      >
                        Cancel
                      </button>
                    )}

                    <button
                      className={`${
                        declineReason.replace(/\s+/g, "").length < 10
                          ? "confirmBtn"
                          : "confirm-btn-enable"
                      }`}
                      // onClick={() =>
                      //   status === "Transaction-bene"
                      //     ? BeneTxnDeclinedDtls(accountId, declineReason)
                      //     : handleConfirm(accountId, declineReason)
                      // }
                      onClick={() => {
                        if (
                          services?.find(
                            (service) =>
                              service === "ABeneficiaryTxn" ||
                              service === "Admin" ||
                              service === "AInternalTxn",
                          ) !== undefined
                        ) {
                          status === "Transaction-bene" ||
                          status === "internal-transaction"
                            ? BeneTxnDeclinedDtls(accountId, declineReason)
                            : handleConfirm(accountId, declineReason);
                        } else {
                          Navigate("/feature_not_assigned", {
                            state: {
                              unavailableService:
                                status === "Transaction-bene"
                                  ? "ABeneficiaryTxn"
                                  : status === "internal-transaction"
                                    ? "AInternalTxn"
                                    : "",
                            },
                          });
                        }
                      }}
                      disabled={
                        inputDisabled ||
                        declineReason.replace(/\s+/g, "").length < 10
                      } // pp
                      style={{
                        cursor:
                          inputDisabled ||
                          declineReason.replace(/\s+/g, "").length <= 10
                            ? "default"
                            : "pointer",
                      }}
                    >
                      Reject
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : status === "Reject-All-Transaction" ? (
          <div
            className="DeclinedAndpopup animate-none Qmd:animate-slideInFromRight"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="declinedReasion">
              <h2>Rejected reason</h2>
              <p>Please state the reason for rejecting the transaction</p>
            </div>

            <div
              className={`Beneinputfield ${
                declineReason.replace(/\s+/g, "").length >= 9 ? "valid" : ""
              }`}
            >
              <input
                style={{
                  border:
                    declineReason.replace(/\s+/g, "").length >= 10
                      ? "1px solid var(--settled)"
                      : isFocus
                        ? "1px solid var(--text-secondary)"
                        : "1px solid var(--text-secondary)",
                  pointerEvents: inputDisabled ? "none" : "auto",
                  disabled: inputDisabled ? "true" : "false",
                  width: "520px",
                  height: "42px",
                  font: "16px",
                  padding: "0px 10px",
                  background: "transparent",
                  borderRadius: "10px",
                  outline: "none",
                  opacity: "1",
                }}
                type="text"
                value={declineReason}
                onChange={handleInputChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                disabled={inputDisabled}
              />
              <label
                htmlFor=""
                for="myInput"
                style={{
                  top: isFocus ? "-0px" : "22px",
                  fontSize: isFocus ? "var(--font-xs)" : "var(--font-md)",
                  background: "var(--Blue-3)",
                  color:
                    declineReason.replace(/\s+/g, "").length >= 10
                      ? "var(--settled)"
                      : isFocus
                        ? "var(--text-secondary)"
                        : "var(--text-secondary)",
                }}
              >
                Reason
              </label>
            </div>
            <div className="txn_note mt-[10px] mb-[20px]">
              <p className="font-sans text-text-secondary text-font-sm font-normal leading-[19px] flex-none order-1">
                Note - The reason must consist of at least 10 characters.
              </p>
            </div>
            <div className="BeneTxn_benefbtnconfandCan">
              {showLoader ? (
                <div>
                  <Loader />
                </div>
              ) : (
                <div className="flex items-center gap-[20px]">
                  {cancleButtonHide && (
                    <button
                      id="cancelBtn"
                      onClick={onClose}
                      className={`cancleBtn ${showTransitionClass}`}
                    >
                      Cancel
                    </button>
                  )}

                  <button
                    className={`${
                      declineReason.replace(/\s+/g, "").length < 10
                        ? "confirmBtn"
                        : "confirm-btn-enable"
                    }`}
                    onClick={() => {
                      if (
                        services?.find(
                          (service) =>
                            service === "ABeneficiaryTxn" ||
                            service === "Admin",
                        ) !== undefined
                      ) {
                        if (associatePending === "AlertPendingTxn") {
                          handlePendingTxn(pendingTxnId);
                        } else {
                          handleRejectAllTransaction();
                        }
                      } else {
                        Navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ABeneficiaryTxn",
                          },
                        });
                      }
                    }}
                    disabled={
                      inputDisabled ||
                      declineReason.replace(/\s+/g, "").length < 10
                    }
                    style={{
                      cursor:
                        inputDisabled ||
                        declineReason.replace(/\s+/g, "").length < 10
                          ? "default"
                          : "pointer",
                    }}
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : status === "Internal_AccountApproval" ||
          status === "Internal_Account_Detail" ||
          status === "Benificiary" ? (
          <SmallPopupWithInput
            headerTitle={TEXT.REJECT_REASON_LABEL}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle={
              type === "BeneAccAlert"
                ? " Please state the reason for rejecting the transaction"
                : " Please state the reason for rejecting the accounts"
            }
            secondHeaderFontWeight="semibold"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            inputPlaceholder={"Reject (10 -150 char)"}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText={TEXT.CANCEL}
            btnOneHandleFunction={() => {
              setRejectTxnPopup(false);
              onClose();
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT.REJECT}
            btnTwoHandleFunction={(e) => {
              if (
                services?.find(
                  (service) =>
                    service === "Admin" ||
                    service === "IAAccount" ||
                    service === "BAAccount",
                ) !== undefined
              ) {
                if (
                  declineReason.replace(/\s+/g, "").length >=
                    GlobalConfiguration.owneraccountnormalLength &&
                  declineReason.length <= GlobalConfiguration.inputMaxLength
                ) {
                  if (type === "BeneAccAlert") {
                    handleRejectAlert();
                  } else {
                    handleRejectTransactionChecker(accountId, declineReason);
                  }
                }
              } else {
                Navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "IAAccount",
                  },
                });
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length <
                GlobalConfiguration.owneraccountnormalLength ||
              declineReason.length > GlobalConfiguration.inputMaxLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        ) : (
          <div className="DeclinedAndpopup animate-none Qmd:animate-slideInFromRight">
            <div className="declinedReasion">
              <h2>Rejected reason</h2>
              <p style={{ color: "var(--text-primary) !important" }}>
                Please state the reason for rejecting the account
              </p>
            </div>
            <div className="Beneinputfield">
              <input
                style={{
                  border:
                    declineReason.replace(/\s+/g, "").length >= 10
                      ? "1px solid var(--settled)"
                      : isFocus
                        ? "1px solid var(--text-secondary)"
                        : "1px solid var(--text-secondary)",
                  pointerEvents: inputDisabled ? "none" : "auto",
                  disabled: inputDisabled ? "true" : "false",
                  width: "95%",
                  maxWidth: "520px",
                  height: "42px",
                  font: "16px",
                  padding: "0px 10px",
                  background: "transparent",
                  borderRadius: "10px",
                  outline: "none",
                  opacity: "1",
                }}
                type="text"
                value={declineReason}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={handleInputChange}
                disabled={inputDisabled}
              />
              <label
                htmlFor=""
                style={{
                  top: isFocus ? "-0px" : "22px",
                  fontSize: isFocus ? "var(--font-xs)" : "var(--font-md)",
                  background: "var(--Blue-3)",
                  color:
                    declineReason.replace(/\s+/g, "").length >= 10
                      ? "var(--settled)"
                      : isFocus
                        ? "var(--text-secondary)"
                        : "var(--text-secondary)",
                }}
              >
                Reason
              </label>
            </div>
            <div className="note-text">
              <p
                className="w-full h-[19px] font-sans text-text-secondary text-font-sm font-normal leading-[19px] flex-none order-1"
                style={{
                  marginTop: isMobile ? "15px" : "10px",
                  marginLeft: isMobile ? "4.5%" : "4.5%",
                }}
              >
                Note - The reason must consist of at least 10 characters.
              </p>
            </div>
            <div className="benefbtnconfandCan">
              {cancleButtonHide && (
                <button
                  id="cancelBtn"
                  onClick={() => {
                    setRejectTxnPopup(false);
                    onClose();
                  }}
                  className={`cancleBtn ${showTransitionClass}`}
                >
                  Cancel
                </button>
              )}
              {showLoader ? (
                <div>
                  <Loader />
                </div>
              ) : (
                <button
                  className={`${
                    declineReason.replace(/\s+/g, "").length < 10
                      ? "confirmBtn"
                      : "confirm-btn-enable"
                  }`}
                  onClick={(e) => {
                    if (
                      services?.find(
                        (service) =>
                          service === "ABeneficiaryTxn" ||
                          service === "Admin" ||
                          service === "AInternalTxn",
                      ) !== undefined
                    ) {
                      if (
                        (e.type === "click" || e.key === "Enter") &&
                        declineReason.replace(/\s+/g, "").length >= 10
                      ) {
                        if (
                          status === "Transaction" ||
                          sideDrawer === "SideDrawer"
                        ) {
                          BeneTxnDeclinedPopUp(accountId, declineReason);
                        } else if (associateschedule === "AlertSchedule") {
                          handleRejectScheduleAlert(beneid, declineReason);
                        } else {
                          handleRejectTransactionChecker(
                            accountId,
                            declineReason,
                          );
                        }
                      }
                    } else {
                      Navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "ABeneficiaryTxn",
                        },
                      });
                    }
                  }}
                  disabled={
                    inputDisabled ||
                    declineReason.replace(/\s+/g, "").length < 10
                  }
                  style={{
                    cursor:
                      inputDisabled ||
                      declineReason.replace(/\s+/g, "").length < 10
                        ? "default"
                        : "pointer",
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Enter" &&
                      declineReason.trim().length >= 10
                    ) {
                      e.preventDefault();
                      e.target.click();
                    }
                  }}
                >
                  Reject
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DeclinedPopup;
